module.exports = __webpack_public_path__ + "static/media/__Annual-Report.9d5bce2b.svg";